import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

const SleepCard = () => {
  return (
    <Card
      elevation={0}
      sx={{
        background: "linear-gradient(97deg, #290569 0%, #1A0245 100%)",
        padding: 1,
      }}
    >
      <CardContent>
        <Box sx={{ mb: 2 }}>
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontWeight: "bold",
              fontSize: { xs: "2rem", md: "2.5rem" },
              lineHeight: 1.2,
              background: "linear-gradient(314deg, #dedaff 0%, #8274ff 100%)",
              backgroundClip: "text",
              textFillColor: "transparent",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              filter: "drop-shadow(18px 11px 17px rgba(123, 110, 246, 0.5))",
            }}
          >
            Sleep Apnea
            <br />
            Care. Simplified.
          </Typography>
        </Box>
        <Typography
          variant="h6"
          sx={{
            color: "text.light",
            fontWeight: "normal",
            fontSize: { xs: "1rem", md: "1.25rem" },
            lineHeight: 1.5,
          }}
        >
          Personalized Sleep Apnea Care
          <br />
          From The Comfort of Home
        </Typography>
      </CardContent>
    </Card>
  );
};

export default SleepCard;
